import { render, staticRenderFns } from "./FormConselho.vue?vue&type=template&id=16bac2ba"
import script from "./FormConselho.vue?vue&type=script&lang=js"
export * from "./FormConselho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports